const getInitialValue = () => {
    return {
        starting: true,
        data: [{ default: 1 }]
    }
}

const WidgetReducer = (state = getInitialValue(), message) => {
    switch (message?.type) {
        case 'start':
            return { ...state, starting: true }
        case 'event':
            const events = message?.events
            return { ...state, data: events }
        case 'destroy': {
            return { ...state, starting: false }
        }
        default:
            break
    }

    return state
}

export default WidgetReducer